import TeamLunch from './TeamLunch';

export default TeamLunch;